import axios from '@/libs/api.request'
//读写接口

//岗位词典添加
export const addPosDic = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/dictionary/add/',
    data,
    method: 'post'
  })
}
//岗位词典删除
export const delPosDic = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/dictionary/delete/',
    data,
    method: 'post'
  })
}
//岗位词典编辑
export const editPosDic = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/dictionary/edit/',
    data,
    method: 'post'
  })
}
//成本中心添加
export const addCost = (data) => {
  return axios.request({
    url: '/employee/costcenter/add',
    data,
    method: 'post'
  })
}
//成本中心编辑
export const editCost = (data) => {
  return axios.request({
    url: '/employee/costcenter/update',
    data,
    method: 'post'
  })
}
//成本中心删除
export const delCost = (data) => {
  return axios.request({
    url: '/employee/costcenter/delete',
    data,
    method: 'post'
  })
}
//岗位类别添加
export const addPosCate = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/category/add/',
    data,
    method: 'post'
  })
}
//岗位类别删除
export const delPosCate = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/category/delete/',
    data,
    method: 'post'
  })
}
//岗位类别编辑
export const editPosCate = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/category/edit/',
    data,
    method: 'post'
  })
}
//岗位职级添加
export const addPosLevel = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/level/add/',
    data,
    method: 'post'
  })
}
//岗位职级删除
export const delPosLevel = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/level/delete/',
    data,
    method: 'post'
  })
}
//岗位职级编辑
export const editPosLevel = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/level/edit/',
    data,
    method: 'post'
  })
}

//岗位添加
export const addPos = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/add/',
    data,
    method: 'post'
  })
}

//岗位删除
export const delPos = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/delete/',
    data,
    method: 'post'
  })
}

// 员工添加
export const addEmployee = (data) => {
  return axios.request({
    url: '/employee/add/',
    data,
    method: 'post'
  })
}

//岗位编制设置
export const setPosStaffingCount = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/staffing/',
    data,
    method: 'post'
  })
}

// 岗位详情
export const getPosDetail = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/detail/',
    params: data,
    method: 'post'
  })
}
// 岗位编辑
export const posDetailEdit = (data) => {
  return axios.request({
    url: '/enterprise/jobposition/edit/',
    params: data,
    method: 'post'
  })
}
// 企业信息编辑
export const editCoprInfo = (data) => {
  return axios.request({
    url: '/enterprise/update',
    data,
    method: 'post'
  })
}
// 上传营业执照
export const uploadLicense = (data) => {
  return axios.request({
    url: '/enterprise/license',
    data,
    method: 'post'
  })
}
// 修改营业执照
export const editLicense = (data) => {
  return axios.request({
    url: '/enterprise/editlicense',
    data,
    method: 'post'
  })
}
// 邀请员工
export const inviteCode = (data) => {
  return axios.request({
    url: '/enterprise/employeeqrcode',
    data,
    method: 'post'
  })
}
// 修改密码
export const modifyPwd = (data) => {
  return axios.request({
    url: '/enterprise/pwd/edit/',
    data,
    method: 'post'
  })
}
//账户信息编辑
export const accountEdit = (data) => {
  return axios.request({
    url: '/enterprise/contract/editinfo/',
    data,
    method: 'post'
  })
}
// 修改账户联系人头像
export const accountEditHeadimg = (data) => {
  return axios.request({
    url: '/enterprise/contract/editheadimg/',
    data,
    method: 'post'
  })
}
// 修改手机号码
export const modifyMobile = (data) => {
  return axios.request({
    url: '/enterprise/contract/editacc/',
    data,
    method: 'post'
  })
}
// 修改手机号时验证码
export const modifyMobileSmsCode = (data) => {
  return axios.request({
    url: '/enterprise/contract/changeaccamssend/',
    data,
    method: 'post'
  })
}
// 登录时手机验证码
export const sentSmsCode = (data) => {
  return axios.request({
    url: '/sms/smssend/',
    data,
    method: 'post'
  })
}
// 员工基本信息编辑
export const editinfo = (data) => {
  return axios.request({
    url: '/employee/editinfo/',
    data,
    method: 'post'
  })
}


//员工头像编辑
export const editheadimg = (data) => {
  return axios.request({
    url: '/employee/editheadimg/',
    data,
    method: 'post'
  })
}

// 员工身份证编辑【王龙】
export const editidcard = (data) => {
  return axios.request({
    url: '/employee/editidcard/',
    data,
    method: 'post'
  })
}

// 员工毕业证书照片\学位证书照片\职业证书
export const editeducationphoto = (data) => {
  return axios.request({
    url: '/employee/editeducationphoto/',
    data,
    method: 'post'
  })
}


// 教育经历编辑
export const editeducation = (data) => {
  return axios.request({
    url: '/employee/editeducation/',
    data,
    method: 'post'
  })
}
// 教育经历删除
export const deleteeducation = (data) => {
  return axios.request({
    url: '/employee/deleteeducation/',
    data,
    method: 'post'
  })
}


// 工作经历编辑
export const editworkexperience = (data) => {
  return axios.request({
    url: '/employee/editworkexperience/',
    data,
    method: 'post'
  })
}
// 工作经历删除
export const deleteworkexperience = (data) => {
  return axios.request({
    url: '/employee/deleteworkexperience/',
    data,
    method: 'post'
  })
}

// 工资卡编辑
export const editbank = (data) => {
  return axios.request({
    url: '/employee/editbank/',
    data,
    method: 'post'
  })
}
// 社保卡编辑
export const editins = (data) => {
  return axios.request({
    url: '/employee/editins/',
    data,
    method: 'post'
  })
}

// 编辑员工联系方式+紧急联系人
export const editcontact = (data) => {
  return axios.request({
    url: '/employee/editcontact/',
    data,
    method: 'post'
  })
}
// 编辑员工证书信息
export const editcertificate = (data) => {
  return axios.request({
    url: '/employee/editcertificate/',
    data,
    method: 'post'
  })
}


// 删除员工职业证书
export const deletecertificate = (data) => {
  return axios.request({
    url: '/employee/deletecertificate',
    data,
    method: 'post'
  })
}


// 编辑员工家庭成员信息
export const editfamily = (data) => {
  return axios.request({
    url: '/employee/editfamily/',
    data,
    method: 'post'
  })
}

// 工作经历删除
export const deletefamily = (data) => {
  return axios.request({
    url: '/employee/deletefamily/',
    data,
    method: 'post'
  })
}

// 编辑员工岗位信息
export const editposition = (data) => {
  return axios.request({
    url: '/employee/editposition/',
    data,
    method: 'post'
  })
}

// 编辑员工招聘渠道信息
export const editrecruitment = (data) => {
  return axios.request({
    url: '/employee/editrecruitment/',
    data,
    method: 'post'
  })
}


// 编辑员工合同信息
export const editcontract = (data) => {
  return axios.request({
    url: '/employee/editcontract/',
    data,
    method: 'post'
  })
}

// 删除员工合同信息
export const deletecontract = (data) => {
  return axios.request({
    url: '/employee/deletecontract/',
    data,
    method: 'post'
  })
}

// 员工合同照片上传
export const editcontractphoto = (data) => {
  return axios.request({
    url: '/employee/editcontractphoto/',
    data,
    method: 'post'
  })
}


// 员工交接单照片、解除表照片上传
export const editformsphoto = (data) => {
  return axios.request({
    url: '/employee/editformsphoto/',
    data,
    method: 'post'
  })
}


// 验证账号是否存在
export const isregister = (data) => {
  return axios.request({
    url: '/enterprise/isregister/',
    data,
    method: 'post'
  })
}

// 新增社保方案
export const insPlanAdd = (data) => {
  return axios.request({
    url: '/Insurance/Plan/Add',
    data,
    method: 'post'
  })
}
// 编辑社保方案
export const insPlanEdit = (data) => {
  return axios.request({
    url: '/Insurance/Plan/Edit',
    data,
    method: 'post'
  })
}
// 删除社保方案
export const insPlanDel = (data) => {
  return axios.request({
    url: '/Insurance/Plan/Delete',
    data,
    method: 'post'
  })
}
// 社保计算小数点规则
export const decimalRule = (data) => {
  return axios.request({
    url: '/Insurance/DecimalRule/List',
    data,
    method: 'post'
  })
}
// 保险类别
export const insType = (data) => {
  return axios.request({
    url: '/Insurance/Type/GetTypeByPlanId',
    data,
    method: 'post'
  })
}


export const holidayAddTypes = (data) => {
  return axios.request({
    url: '/holiday/addTypes',
    data,
    method: 'post'
  })
}


// 【1005】给假期类型添加方案（病假，事假）【李旭阳】
export const addHolidaySolutionForType1 = (data) => {
  return axios.request({
    url: '/holiday/addHolidaySolutionForType1',
    data,
    method: 'post'
  })
}

// 【1006】给假期类型添加方案（婚假，产假，陪产假，工伤假，流产假，奖励产假，丧假，探亲假，产检假）【李旭阳】
export const addHolidaySolutionForType2 = (data) => {
  return axios.request({
    url: '/holiday/addHolidaySolutionForType2',
    data,
    method: 'post'
  })
}
// 【1007】给假期类型添加方案（企业自定义类型）【李旭阳】
export const addHolidaySolutionForType3 = (data) => {
  return axios.request({
    url: '/holiday/addHolidaySolutionForType3',
    data,
    method: 'post'
  })
}
// 【1008】给假期类型添加方案（长期病假）【李旭阳】
export const addHolidaySolutionForType4 = (data) => {
  return axios.request({
    url: '/holiday/addHolidaySolutionForType4',
    data,
    method: 'post'
  })
}

// 【1009】给假期类型添加方案（年假）【李旭阳】
export const addHolidaySolutionForType5 = (data) => {
  return axios.request({
    url: '/holiday/addHolidaySolutionForType5',
    data,
    method: 'post'
  })
}

// 上社保-根据参保方案
export const insAddByPlan = (data) => {
  return axios.request({
    url: '/Insurance/Employee/AddByPlan',
    data,
    method: 'post'
  })
}

// 更新假期方案
export const updateHolidaySolution = (data) => {
  return axios.request({
    url: '/holiday/update',
    data,
    method: 'post'
  })
}

// 上社保-已参保,增加险种
export const insAddBy = (data) => {
  return axios.request({
    url: '/Insurance/Employee/Add',
    data,
    method: 'post'
  })
}

// 删除假期方案
export const deleteHolidaySolution = (data) => {
  return axios.request({
    url: '/holiday/deleteSolution',
    data,
    method: 'post'
  })
}

// 删除假期类型
export const deleteHolidayType = (data) => {
  return axios.request({
    url: '/holiday/deleteTypes',
    data,
    method: 'post'
  })
}

// 保险中断
export const insStop = (data) => {
  return axios.request({
    url: '/Insurance/Employee/Stop',
    data,
    method: 'post'
  })
}

// 添加考勤方案【李旭阳】
export const solutionAdd = (data) => {
  return axios.request({
    url: '/solution/add',
    data,
    method: 'post'
  })
}
// 考勤方案编辑【李旭阳】
export const solutionDelete= (data) => {
  return axios.request({
    url: '/solution/delete',
    data,
    method: 'post'
  })
}

// 考勤方案删除【李旭阳】
export const solutionUpdate = (data) => {
  return axios.request({
    url: '/solution/update',
    data,
    method: 'post'
  })
}

// 保险补缴
export const insRePay = (data) => {
  return axios.request({
    url: '/Insurance/Employee/RePay',
    data,
    method: 'post'
  })
}

//参保记录
export const insChangeDtl = (data) => {
  return axios.request({
    url: '/Insurance/Change/Detail',
    data,
    method: 'post'
  })
}

// 添加考勤组【李旭阳】
export const groupAdd = (data) => {
  return axios.request({
    url: '/group/add',
    data,
    method: 'post'
  })
}

// 删除考勤组【李旭阳】
export const groupDelete = (data) => {
  return axios.request({
    url: '/group/delete',
    data,
    method: 'post'
  })
}
//更新考勤组【李旭阳】
export const groupUpdate = (data) => {
  return axios.request({
    url: '/group/update',
    data,
    method: 'post'
  })
}



// 添加班次【李旭阳】
export const workShiftAdd = (data) => {
  return axios.request({
    url: '/group/workShiftAdd',
    data,
    method: 'post'
  })
}
// 删除考勤组班次【李旭阳】
export const workShiftDelete = (data) => {
  return axios.request({
    url: '/group/workShiftDelete',
    data,
    method: 'post'
  })
}

// 更新考勤组班次【李旭阳】
export const workShiftUpdate = (data) => {
  return axios.request({
    url: '/group/workShiftUpdate',
    data,
    method: 'post'
  })
}


// 薪酬结构--编辑【王龙】
export const salaryStructureEdit = (data) => {
  return axios.request({
    url: '/salary/structure/edit',
    data,
    method: 'post'
  })
}


//薪酬--员工薪酬五大项数据更改【韩雪龙】
export const updateempsalary = (data) => {
  return axios.request({
    url: '/salary/historysalary/updateempsalary',
    data,
    method: 'post'
  })
}

// 薪酬--员工薪酬更改考勤扣款项【韩雪龙】
export const updateempattendance = (data) => {
  return axios.request({
    url: '/salary/historysalary/updateempattendance',
    data,
    method: 'post'
  })
}

// 薪酬--员工薪酬更改社保
export const updateempinsurance = (data) => {
  return axios.request({
    url: '/salary/historysalary/updateempinsurance',
    data,
    method: 'post'
  })
}


// 计薪方案--添加或编辑【王龙】
export const salaryPayableEdit = (data) => {
  return axios.request({
    url: '/salary/payable/edit',
    data,
    method: 'post'
  })
}

// 计薪方案--删除【王龙】
export const salaryPayableDelete = (data) => {
  return axios.request({
    url: '/salary/payable/delete',
    data,
    method: 'post'
  })
}

// 薪酬-企业设置-编辑
export const salaryCorpSetEdit = (data) => {
  return axios.request({
    url: '/salary/setting/edit/',
    data,
    method: 'post'
  })
}

//薪酬计税方案--编辑【韩雪龙】
export const taxEdit = (data) => {
  return axios.request({
    url: '/salary/tax/edit/',
    data,
    method: 'post'
  })
}

// 薪酬计税方案--设置默认项【韩雪龙】
export const taxSetupdefault = (data) => {
  return axios.request({
    url: '/salary/tax/setupdefault/',
    data,
    method: 'post'
  })
}


// 薪酬津贴方案--添加修改【韩雪龙】
export const allowanceAdd = (data) => {
  return axios.request({
    url: '/salary/allowance/add/',
    data,
    method: 'post'
  })
}
// 薪酬津贴方案--删除【韩雪龙】
export const allowanceDelete = (data) => {
  return axios.request({
    url: '/salary/allowance/delete/',
    data,
    method: 'post'
  })
}

// 调薪记录添加
export const adjustAdd = (data) => {
  return axios.request({
    url: '/salary/adjustment/add/',
    data,
    method: 'post'
  })
}
// 调薪记录编辑
export const adjustEdit = (data) => {
  return axios.request({
    url: '/salary/adjustment/edit/',
    data,
    method: 'post'
  })
}

// 调薪记录删除
export const adjustDel = (data) => {
  return axios.request({
    url: '/salary/adjustment/delete/',
    data,
    method: 'post'
  })
}

// 调薪记录撤销
export const adjustCancel = (data) => {
  return axios.request({
    url: '/salary/adjustment/cancellation/',
    data,
    method: 'post'
  })
}
// 添加年终奖
export const yearBonusAdd = (data) => {
  return axios.request({
    url: '/salary/yearbonus/add/',
    data,
    method: 'post',
  })
}

// 删除年终奖
export const yearBonusDel = (data) => {
  return axios.request({
    url: '/salary/yearbonus/delete/',
    data,
    method: 'post',
  })
}

// 编辑员工个人年终奖
export const emplBonusEdit = (data) => {
  return axios.request({
    url: '/salary/yearbonus/edit/',
    data,
    method: 'post',
  })
}

// 删除员工个人年终奖
export const emplBonusDel = (data) => {
  return axios.request({
    url: '/salary/yearbonus/deleteemp/',
    data,
    method: 'post',
  })
}

// 添加自定义流程
export const approvalAdd = (data) => {
  return axios.request({
    url: '/approval/approvalflow/add',
    data,
    method: 'post',
  })
}

// 编辑员工社保-直接修改费用
export const editInsCost = (data) => {
  return axios.request({
    url: '/Insurance/Employee/EditCost',
    data,
    method: 'post'
  })
}

// 编辑员工社保-根据参保方案
export const editInsByPlan = (data) => {
  return axios.request({
    url: '/Insurance/Employee/EditByPlan',
    data,
    method: 'post'
  })
}

// 保存审批表单
export const updateAprlFormCtrl = (data) => {
  return axios.request({
    url: '/approval/approvalflow/updateapprovalflowtemplatecontrols',
    data,
    method: 'post'
  })
}

// 保存审批流
export const updateAprlFlowPathItem = (data) => {
  return axios.request({
    url: '/approval/approvalflow/updateapprovalflowtemplateflowitems',
    data,
    method: 'post'
  })
}


// 工资--生成工资
export const salaryGenerate = (data => {
  return axios.request({
    url: '/salary/generate',
    data,
    method: 'post'
  })
})


// 工资--计算工资
export const salaryCalculation = (data => {
  return axios.request({
    url: '/salary/calculation',
    data,
    method: 'post'
  })
})

// 新建审批
export const addApproval = (data => {
  return axios.request({
    url: '/approval/approvalflow/add',
    data,
    method: 'post'
  })
})

// 删除审批
export const delApproval = (data => {
  return axios.request({
    url: '/approval/approvalflow/deleteflowtemplate',
    data,
    method: 'post'
  })
})



// 删除薪酬列表
export const salaryDelete = (data => {
  return axios.request({
    url: '/salary/deletesalary',
    data,
    method: 'post'
  })
})


// 调岗
export const applyAdjustPosition = (data => {
  return axios.request({
    url: '/app/employee/ApplyAdjustPosition',
    data,
    method: 'post'
  })
})



// 后台发起离职审批流
export const applyDimission = (data => {
  return axios.request({
    url: '/employee/ApplyDimission',
    data,
    method: 'post'
  })
})


// 管理员修改考勤
export const insertCheckIn = (data => {
  return axios.request({
    url: '/AttendanceGlobal/InsertCheckIn',
    data,
    method: 'post'
  })
})


// 删除员工信息
export const deleteEmployee = (data => {
  return axios.request({
    url: '/employee/delete',
    data,
    method: 'post'
  })
})

// 修改审批名称
export const updateFlowName = (data) => {
  return axios.request({
    url: '/approval/approvalflow/updateapprovalflowtemplatename',
    data,
    method: 'post'
  })
}


// 审批 数据接口 禁用、开启开关
export const  updatesyscontrolstate= (data) => {
  return axios.request({
    url: '/flow/updatesyscontrolstate',
    data,
    method: 'post'
  })
}



//系统添加数据值接口
export const  addsysvalueurl= (data) => {
  return axios.request({
    url: '/flow/addsysvalueurl',
    data,
    method: 'post'
  })
}


//系统 删除接口
export const  deletesyscontrolstate= (data) => {
  return axios.request({
    url: '/flow/deletesyscontrolstate',
    data,
    method: 'post'
  })
}

//系统添加数据列表接口
export const  addsyslisturl= (data) => {
  return axios.request({
    url: '/flow/addsyslisturl',
    data,
    method: 'post'
  })
}

//个税纠错提交
export const taxCorrection = (data) => {
  return axios.request({
    url: '/salary/taxcorrection',
    data,
    method: 'post'
  })
}


//个税纠错恢复
export const taxRestore = (data) => {
  return axios.request({
    url: '/salary/restore',
    data,
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/writeIn.js